import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RidExpressiveReading } from '../../../../mechanics/rid-expressive-reading/rid-expressive-reading';

@Component({
  selector: 'app-expressive-reading-page',
  imports: [RidExpressiveReading],
  templateUrl: './expressive-reading-page.html',
})
export class ExpressiveReadingPage {
  protected readonly $router = inject(Router);
}
